import { render, staticRenderFns } from "./ImportCatalog.vue?vue&type=template&id=578d64b9"
import script from "./ImportCatalog.vue?vue&type=script&lang=js"
export * from "./ImportCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports